import Vue from 'vue';
import Vuex from 'vuex';

import i18n from '@/assets/i18n.json';

Vue.use(Vuex);

const language = localStorage.getItem('i18n');

const store = new Vuex.Store({
    state: {
        language: language || 'zh',
        routerType: 'large'
    },
    getters: {
        local: (state) => {
            const l = state.language;
            return i18n[l];
        }
    },
    mutations: {
        setLanguage(state, language) {
            localStorage.setItem('i18n', language);
            state.language = language;
        },
        setRouterType: (state, routerType) => {
            state.routerType = routerType;
        }
    },
    actions: {
        setLanguage(context, language) {
            context.commit('setLanguage', language);
        }
    }
});

export default store;
